import DoubleSlider$2 from './_DoubleSlider.js';
import { jsx } from 'react/jsx-runtime';

var DoubleSlider = function DoubleSlider(_ref) {
  var filterPluralUnitLabel = _ref.filterPluralUnitLabel,
    filterSingularUnitLabel = _ref.filterSingularUnitLabel,
    filterSliderToLabel = _ref.filterSliderToLabel,
    hidden = _ref.hidden,
    maxValue = _ref.maxValue,
    minValue = _ref.minValue,
    onChangeComplete = _ref.onChangeComplete,
    selectedHighValue = _ref.selectedHighValue,
    selectedLowValue = _ref.selectedLowValue,
    separationLimit = _ref.separationLimit,
    step = _ref.step,
    uniqueId = _ref.uniqueId;
  if (typeof onChangeComplete !== 'function' || typeof selectedLowValue !== 'number' || typeof selectedHighValue !== 'number' || typeof selectedLowValue === 'number' && typeof selectedHighValue === 'number' && selectedHighValue <= selectedLowValue) {
    return false;
  }
  var getDisplayedValue = function getDisplayedValue(value) {
    if (value > 1) {
      return filterPluralUnitLabel ? "".concat(value, " ").concat(filterPluralUnitLabel) : value;
    }
    return filterSingularUnitLabel ? "".concat(value, " ").concat(filterSingularUnitLabel) : value;
  };
  return /*#__PURE__*/jsx(DoubleSlider$2, {
    filterSliderToLabel: filterSliderToLabel,
    format: getDisplayedValue,
    hidden: hidden,
    highValue: selectedHighValue,
    lowValue: selectedLowValue,
    max: maxValue,
    min: minValue,
    onChangeComplete: onChangeComplete,
    separationLimit: separationLimit,
    step: step,
    uniqueId: uniqueId
  });
};
DoubleSlider.defaultProps = {
  filterSliderToLabel: null,
  hidden: false,
  maxValue: 0,
  minValue: 0,
  selectedHighValue: 10,
  selectedLowValue: 2,
  separationLimit: 1,
  step: 1,
  uniqueId: ''
};
var DoubleSlider$1 = DoubleSlider;

export { DoubleSlider$1 as default };
//# sourceMappingURL=DoubleSlider.js.map
